import { create } from "zustand";

const useChallengeUIStore = create((set) => ({
  showDetails: false,
  setShowDetails: (value) => set({ showDetails: value }),
}));

export default useChallengeUIStore;
